import React, { useState } from "react";
import "./Contact.css";

export default function Contact() {
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;

    const data = new FormData(form);

    try {
      const res = await fetch("https://formspree.io/f/xjkrzeyn", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      });

      if (res.ok) {
        setStatus("Message sent successfully! ✅");
        form.reset();
      } else {
        setStatus("Something went wrong. Please try again. ❌");
      }
    } catch (err) {
      setStatus("Network error. Try again later. ⚠️");
    }
  };

  return (
    <section id="contact" className="contact-section">
      <h2>Contact Me</h2>
      <p>I'd love to hear from you. Please fill out the form below.</p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <input type="text" name="name" placeholder="Your Name" required />
        </div>
        <div className="form-group">
          <input type="email" name="email" placeholder="Your Email" required />
        </div>
        <div className="form-group">
          <input type="text" name="subject" placeholder="Subject" />
        </div>
        <div className="form-group">
          <textarea name="message" placeholder="Your Message" rows="5" required></textarea>
        </div>
        <button type="submit" className="submit-btn">Send Message</button>

        {status && <p className="status-message">{status}</p>}
      </form>
    </section>
  );
}
